import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, CanActivateFn } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * Guard para proteger rutas privadas
 * Espera a que la inicialización de MSAL termine ('checking')
 * y luego decide si permite el acceso.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Convertimos el signal de authStatus a un Observable
  return toObservable(authService.authStatus).pipe(
    // Esperamos a que pase de 'checking' a 'authenticated' o 'not-authenticated'
    filter((status) => status !== 'checking'),
    // Tomamos solo el primer valor que no sea 'checking'
    take(1),
    map((status) => {
      if (status === 'authenticated') {
        return true;
      }

      // Si no está autenticado, redirigir al login guardando la URL previa
      return router.createUrlTree(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
    })
  );
};
